import { createAction, props } from '@ngrx/store';
import { DateRangeModel } from 'app/core/mips/common/models/date-range.model';

export const setTimeDicerDateRangeSelection = createAction('[DateRange] Set TimeDicerDateRange', props<{ week: DateRangeModel }>());
export const clearTimeDicerDateRangeSelection = createAction('[DateRange] Clear TimeDicerDateRange');